import Main from '../components/Main/Main';
import OnlineAssessment from '../components/OnlineAssessment/OnlineAssessment';
import Section from '../components/Section/Section';

function OnlineAssessmentPage() {
    return (
        <Main>
            <Section title="Online assessment">
                <OnlineAssessment />
            </Section>
        </Main>
    );
}

export default OnlineAssessmentPage;